const ua = navigator.userAgent.toLowerCase()

export default {
    isMobile: /(iphone|ipod|ipad|ios|android|nokia|blackberry|webos|webos|webmate|bada|lg|ucweb)/.test(ua),
    isIos: /(iphone|ipod|ipad|ios)/.test(ua),
    isAndroid: /(android)/.test(ua),
    isWeiXin: /micromessenger/.test(ua),
    isQQBrowser: /qqbrowser/.test(ua)
}